import { useTranslations } from 'next-intl'
import { useSupabaseAuth } from '@/context/supabaseContext'

type GetButtonTextProps = {
  isGated?: boolean
  isLocked: boolean
  lockedButtonTitle?: string
}

/**
 * Button text follows the platform-wide members-only download rule (Veronika,
 * 2026-08-26): logged-out visitors always see the create-account prompt,
 * regardless of the legacy isGated/isLocked flags.
 */
export const useResourceDownloadButtonText = ({
  isLocked: _isLocked,
  lockedButtonTitle,
}: GetButtonTextProps) => {
  const { user, isLoaded } = useSupabaseAuth()
  const t = useTranslations('public')

  if (!isLoaded || !user) {
    return lockedButtonTitle || t('createAccountToDownload')
  }

  return t('downloadFree', { defaultValue: 'Download Free' })
}
